import {Component, inject} from '@angular/core';
import {IxActiveModal} from '@siemens/ix-angular';

@Component({
  selector: 'app-simple-modal',
  standalone: false,
  templateUrl: './simple-modal.component.html',
  styleUrl: './simple-modal.component.scss',
})
export class SimpleModalComponent {
  activeModal = inject(IxActiveModal);
}
